import api from '../api';
import { AxiosResponse } from 'axios';

interface SubscriptionResponse {
  subscription: {
    id: string;
    status: string;
    currentPeriodEnd: string;
    cancelAtPeriodEnd: boolean;
  };
}

interface PaymentLinkResponse {
  url: string;
}

class SubscriptionService {
  private readonly baseUrl = '/subscription';

  async getPaymentLink(): Promise<PaymentLinkResponse> {
    const response: AxiosResponse<PaymentLinkResponse> = await api.post(
      `${this.baseUrl}/create-payment-link`
    );
    return response.data;
  }

  async getCurrentSubscription(): Promise<SubscriptionResponse> {
    const response: AxiosResponse<SubscriptionResponse> = await api.get(
      `${this.baseUrl}/current`
    );
    return response.data;
  }

  async cancelSubscription(): Promise<{ message: string; cancelDate: string }> {
    const response: AxiosResponse<{ message: string; cancelDate: string }> = await api.post(
      `${this.baseUrl}/cancel`
    );
    return response.data;
  }
}

export const subscriptionService = new SubscriptionService();
